package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Card
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.Divider
import androidx.compose.material.DropdownMenu
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.OutlinedButton
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.DrawerState
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.navigation.AddNew
import com.hyperether.goodjob.navigation.AddNewContact
import com.hyperether.goodjob.navigation.AddNewJob
import com.hyperether.goodjob.navigation.AddNewUser
import com.hyperether.goodjob.repository.prefs.Preferences
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add
import com.hyperether.goodjob.resources.baseline_person_24
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.country_icon
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.filter
import com.hyperether.goodjob.resources.filter_svgrepo_com_1
import com.hyperether.goodjob.resources.ic_back
import com.hyperether.goodjob.resources.ic_search
import com.hyperether.goodjob.resources.icon
import com.hyperether.goodjob.resources.map_pin
import com.hyperether.goodjob.resources.monthly
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.plus
import com.hyperether.goodjob.resources.resend_confirmation_link
import com.hyperether.goodjob.resources.search
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.resources.yearly
import com.hyperether.goodjob.theme.AddEmployeeInputColor
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.FilterOption
import com.hyperether.goodjob.theme.PricingBoxBg
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants.DEFAULT_CONTACT_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_EMPLOYEE_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.NestedComposeViewPort
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.AppLocale
import com.hyperether.resources.LocalizedStrings
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import com.hyperether.resources.stringResourcePlain
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun Loader(modifier: Modifier = Modifier) {
    // Implement your Loader composable here
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        CircularProgressIndicator()
    }

}

@Composable
fun MobileHeaderSearchAction(
    title: String,
    onOpenDrawer: () -> Unit,
    isInDeleteMode: Boolean = false,
    onDeleteClick: () -> Unit = {},
    onCancelSearch: () -> Unit,
    actionImage: DrawableResource = Res.drawable.filter_svgrepo_com_1,
    scope: CoroutineScope,
    isActionVisible: Boolean = true,
    action: () -> Unit,
    search: () -> Unit,
    user: User?
) {
    var searchEnabled by remember { mutableStateOf(false) }

    Column {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
                .padding(horizontal = 16.toScaleDp(), vertical = 10.toScaleDp())
        ) {
            Box(
                modifier = Modifier.weight(1f)
            ) {
                CircleWithInitialUser(user, size = 40.toScaleDp(), modifier = Modifier.clickable {
                    onOpenDrawer()
                })
            }

            Text18Bold(
                text = title, modifier = Modifier.weight(2f)
            )

            Row(
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.weight(1f)
            ) {
                if (searchEnabled) {
                    DisableSelection {
                        TextButton(onClick = {
                            searchEnabled = false
                            onCancelSearch()
                        }) {
                            Text(stringResource(Res.string.cancel), color = BlueApp)
                        }
                    }
                } else {
                    if (isInDeleteMode) {
                        IconButton(onClick = onDeleteClick) {
                            DisableSelection {
                                Image(
                                    painter = painterResource(Res.drawable.trash),
                                    contentDescription = "Add icon",
                                    modifier = Modifier.padding()
                                )
                            }
                        }
                    } else {
                        IconButton(onClick = {
                            searchEnabled = true
                            search()
                        }, modifier = Modifier.padding(end = 20.toScaleDp())) {
                            Image(
                                painter = painterResource(Res.drawable.icon),
                                contentDescription = "Search icon"
                            )
                        }
                        if (isActionVisible) {
                            IconButton(onClick = action) {
                                Icon(
                                    painter = painterResource(actionImage),
                                    contentDescription = "action"
                                )
                            }
                        }
                    }
                }
            }
        }
        Divider(
            modifier = Modifier.height(2.toScaleDp()).background(Color.LightGray.copy(alpha = 0.1f))
        )
    }
}

@Composable
fun MobileHeaderSearchAdd(
    title: String,
    drawerState: DrawerState,
    isInDeleteMode: Boolean = false,
    isAllSelected: Boolean = true,
    onDeleteClick: () -> Unit = {},
    scope: CoroutineScope,
    add: () -> Unit,
    search: () -> Unit,
    onCancelSearch: () -> Unit = {},
    image: DrawableResource = Res.drawable.baseline_person_24,
    searchOnMap: Boolean = false,
    removeSearch: Boolean = false,
    user: User?
) {
    var searchEnabled by remember { mutableStateOf(false) }

    Column {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
                .padding(horizontal = 16.toScaleDp(), vertical = 10.toScaleDp())
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.weight(1f)
            ) {
                CircleWithInitialUser(user, size = 40.toScaleDp(), modifier = Modifier.clickable {
                    scope.launch { drawerState.open() }
                })
                Spacer(modifier = Modifier.width(16.toScaleDp()))
                if (!getPlatformChecker().isMobile()) {
                    DisableSelection {
                        LanguageToggle(isWebMobile = true)
                    }
                }
            }

            Text18Bold(
                text = title, modifier = Modifier.weight(1f)
            )

            Row(
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.weight(1f)
            ) {
                if (searchEnabled) {
                    TextButton(onClick = {
                        searchEnabled = false
                        onCancelSearch()
                    }) {
                        DisableSelection {
                            Text(
                                stringResource(Res.string.cancel),
                                color = BlueApp,
                                fontSize = 14.toScaleSp()
                            )
                        }
                    }
                } else {
                    if (isInDeleteMode) {
                        Box(
                            modifier = Modifier.height(40.dp)
                        ) {
                            IconButton(onClick = onDeleteClick) {
                                DisableSelection {
                                    Image(
                                        painter = painterResource(Res.drawable.trash),
                                        contentDescription = "Add icon",
                                        modifier = Modifier.padding().size(20.toScaleDp())
                                    )
                                }
                            }
                        }
                    } else {
                        if (isAllSelected) {
                            IconButton(
                                onClick = {
                                    if (!searchOnMap) {
                                        searchEnabled = true
                                    }
                                    search()
                                },
                                modifier = Modifier.padding(
                                    end = 10.toScaleDp(),
                                    start = 15.toScaleDp()
                                ).size(20.toScaleDp())
                            ) {
                                if (!removeSearch) {
                                    Image(
                                        painter = if (searchOnMap) {
                                            painterResource(Res.drawable.map_pin)
                                        } else {
                                            painterResource(Res.drawable.icon)
                                        },
                                        contentDescription = "Search icon"
                                    )
                                }
                            }

                            if (user?.role.equals(Role.superAdmin.name, ignoreCase = true) ||
                                user?.role.equals(Role.admin.name, ignoreCase = true) ||
                                user?.role.equals(Role.manager.name, ignoreCase = true)
                            ) {
                                IconButton(onClick = { add() }) {
                                    Image(
                                        painter = painterResource(Res.drawable.plus),
                                        contentDescription = "Add icon",
                                        modifier = Modifier.padding().size(20.toScaleDp())
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
        Divider(
            modifier = Modifier.height(2.toScaleDp()).background(Color.LightGray.copy(alpha = 0.1f))
        )
    }
}

@Composable
fun MobileHeaderBackAndAction(
    title: String,
    back: () -> Unit,
    actionEnabled: Boolean = false,
    content: @Composable (() -> Unit)? = null
) {
    Column {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 10.toScaleDp(), horizontal = 20.toScaleDp())
                .height(48.toScaleDp())
        ) {
            Box(modifier = Modifier.weight(1f)) {
                IconButton(modifier = Modifier.size(20.toScaleDp()), onClick = { back() }) {
                    Image(
                        painter = painterResource(Res.drawable.ic_back),
                        contentDescription = "",
                        modifier = Modifier.size(20.toScaleDp())
                    )
                }

            }

            Text18Bold(
                text = title, modifier = Modifier.weight(2f)
            )

            Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.CenterEnd) {
                if (actionEnabled) {
                    content?.let { it() }
                }
            }
        }
        Divider(
            modifier = Modifier.height(2.toScaleDp()).background(Color.LightGray.copy(alpha = 0.1f))
        )
    }
}

@Composable
fun SubscriptionToggle(
    isDark: Boolean,
    isMobile: Boolean,
    traceColor: Color = Color.White,
    selectedOption: String,
    onOptionSelected: (String) -> Unit
) {
    val options = mapOf(
        LocalizedStrings.get(
            Res.string.monthly.key,
            AppLocale.DEFAULT
        ) to stringResourcePlain(Res.string.monthly),
        LocalizedStrings.get(
            Res.string.yearly.key,
            AppLocale.DEFAULT
        ) to stringResourcePlain(Res.string.yearly)
    )
    Box(
        modifier = Modifier
            .height(48.toScaleDp())
            .then(
                if (isMobile) Modifier.fillMaxWidth()
                else Modifier.width(300.toScaleDp())
            )
            .padding(horizontal = 20.toScaleDp())
            .background(
                if (!isDark) traceColor else PricingBoxBg,
                shape = RoundedCornerShape(15.toScaleDp())
            ),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier.padding(
                horizontal = 5.toScaleDp(),
                vertical = 5.toScaleDp()
            )
        ) {
            options.forEach { (optionDefault, option) ->
                val isSelected = selectedOption == optionDefault
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .width(167.toScaleDp())
                        .height(38.toScaleDp())
                        .background(
                            if (isSelected) BlueApp else Color.Transparent,
                            shape = RoundedCornerShape(16.toScaleDp())
                        )
                        .clickableWithPointer { onOptionSelected(optionDefault) },
                    contentAlignment = Alignment.Center
                ) {
                    DisableSelection {
                        Text(
                            text = option,
                            color = if (isSelected) Color.White else if (!isDark) Color.Black else Color.White,
                            fontSize = 16.toScaleSp(),
                            lineHeight = 19.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun WebViewHeader(
    isAddNewUser: Boolean = false,
    isAddNewJob: Boolean = false,
    isAddNewContact: Boolean = false,
    isLanguageVisible: Boolean = false,
    isBackAvailable: Boolean,
    onBackClick: (() -> Unit)? = null,
    title: String,
    isImportAndAddVisible: Boolean,
    navHostController: NavHostController
) {
    Row(
        modifier = Modifier
            .background(Color.White)
            .fillMaxWidth()
            .height(86.toScaleDp())
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = BorderColor,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(horizontal = 75.toScaleDp(), vertical = 25.toScaleDp()),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (isBackAvailable) {
            IconButton(
                onClick = { onBackClick?.invoke() },
                modifier = Modifier
                    .size(20.toScaleDp())
                    .pointerHoverIcon(PointerIcon.Hand)
            ) {
                Image(
                    modifier = Modifier.size(20.toScaleDp()),
                    painter = painterResource(Res.drawable.ic_back),
                    contentDescription = "Back button"
                )
            }
            Spacer(modifier = Modifier.width(30.toScaleDp()))
        }
        Text(
            text = title,
            fontSize = 32.toScaleSp(),
            fontWeight = FontWeight.Bold,
            lineHeight = 38.toScaleSp(),
            modifier = Modifier.weight(1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {
            // TODO: uncomment import list
//                Text(
//                    text = stringResource(Res.string.import_list),
//                    fontSize = Sp(16f),
//                    lineHeight = Sp(19f)
//                )
            Spacer(modifier = Modifier.width(32.toScaleDp()))
            if (isLanguageVisible) {
                DisableSelection {
                    LanguageToggle()
                }
            }
            if (isImportAndAddVisible) {
                DashboardAddButton(
                    isAddNewUser,
                    isAddNewJob,
                    isAddNewContact,
                    navHostController
                )
            }
        }
    }
}

@Composable
fun DashboardAddButton(
    isAddNewUser: Boolean = false,
    isAddNewJob: Boolean = false,
    isAddNewContact: Boolean = false,
    navHostController: NavHostController
) {
    Button(
        modifier = Modifier
            .height(35.toScaleDp())
            .widthIn(min = 85.toScaleDp())
            .pointerHoverIcon(PointerIcon.Hand),
        onClick = {
            if (isAddNewUser) {
                navHostController.navigate(AddNewUser(DEFAULT_EMPLOYEE_ID))
            } else if (isAddNewJob) {
                navHostController.navigate(AddNewJob(DEFAULT_JOB_ID))
            } else if (isAddNewContact) {
                navHostController.navigate(AddNewContact(DEFAULT_CONTACT_ID))
            } else {
                navHostController.navigate(AddNew)
            }
        },
        colors = ButtonDefaults.buttonColors(BlueApp),
        shape = RoundedCornerShape(32.toScaleDp())
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {
            DisableSelection {
                Text(
                    text = stringResource(Res.string.add),
                    color = Color.White,
                    fontSize = 16.toScaleSp(),
                    fontWeight = FontWeight.W400
                )
            }
            Spacer(modifier = Modifier.width(8.toScaleDp()))
            Icon(
                imageVector = Icons.Default.Add,
                contentDescription = stringResource(Res.string.add),
                tint = Color.White,
                modifier = Modifier.size(16.toScaleDp())
            )
        }
    }
}

@Composable
fun LanguageToggle(isWebMobile: Boolean = false) {
    var expanded by remember { mutableStateOf(false) }

    BoxWithConstraints {
        val minWidthForIcon = 70.toScaleDp()
        val showIcon = maxWidth > minWidthForIcon

        Row(
            modifier = Modifier
                .padding(end = if (isWebMobile) 0.dp else 20.toScaleDp())
                .clip(RoundedCornerShape(10.toScaleDp()))
                .clickableWithPointer { expanded = !expanded }
                .padding(all = 4.toScaleDp()),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start
        ) {
            if (showIcon) {
                Image(
                    painter = painterResource(Res.drawable.country_icon),
                    contentDescription = "Language icon",
                    modifier = Modifier
                        .padding(end = 8.toScaleDp())
                        .size(20.toScaleDp())
                )
            }

            Text(
                text = currentLanguage.value.code.uppercase(),
                color = BlueApp,
                fontSize = 14.toScaleSp(),
            )

            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
            ) {
                AppLocale.entries.forEach { language ->
                    DropdownMenuItem(
                        modifier = Modifier.pointerCursorIfEnabled(true),
                        text = { Text(language.code.uppercase()) },
                        onClick = {
                            saveLanguageToPref(language.code)
                            currentLanguage.value = language
                            expanded = false
                        }
                    )
                }
            }
        }
    }
}

@Composable
fun WebViewHeaderWithRightContent(
    isBackAvailable: Boolean,
    onBackClick: (() -> Unit)? = null,
    title: String,
    content: @Composable () -> Unit
) {
    Row(
        modifier = Modifier
            .background(Color.White)
            .fillMaxWidth()
            .height(86.toScaleDp())
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = BorderColor,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(horizontal = 75.toScaleDp(), vertical = 25.toScaleDp()),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (isBackAvailable) {
            IconButton(
                modifier = Modifier.size(20.toScaleDp())
                    .pointerHoverIcon(PointerIcon.Hand),
                onClick = { onBackClick?.invoke() }
            ) {
                Image(
                    modifier = Modifier.size(20.toScaleDp()),
                    painter = painterResource(Res.drawable.ic_back),
                    contentDescription = "Back button"
                )
            }
            Spacer(modifier = Modifier.width(30.toScaleDp()))
        }
        Text(
            text = title,
            fontSize = 32.toScaleSp(),
            fontWeight = FontWeight.Bold,
            lineHeight = 38.toScaleSp(),
            modifier = Modifier.weight(1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        content()
    }
}

@Composable
fun PopUpDialog(
    onDismiss: () -> Unit,
    onNegativeBtnClicked: (() -> Unit)? = null,
    onPositiveBtnClicked: () -> Unit,
    title: String,
    message: String,
    negativeBtnText: String? = null,
    positiveBtnText: String
) {
    DisableSelection {
        Dialog(
            onDismissRequest = onDismiss,
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Surface(
                shape = RoundedCornerShape(12.toScaleDp()),
                elevation = 8.toScaleDp(),
                color = Color.White,
                modifier = Modifier
                    .width(400.toScaleDp())
                    .wrapContentHeight()
                    .padding(16.toScaleDp())
            ) {
                Column(
                    modifier = Modifier
                        .padding(24.toScaleDp()),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SelectionContainer {
                        Text(
                            text = title,
                            fontSize = 22.toScaleSp(),
                            color = BlueApp,
                            fontWeight = FontWeight.SemiBold,
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 16.toScaleDp())
                        )
                    }

                    SelectionContainer {
                        Text(
                            text = message,
                            fontSize = 16.toScaleSp(),
                            lineHeight = 20.toScaleSp(),
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 24.toScaleDp())
                        )
                    }

                    // Action buttons
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        if (negativeBtnText != null && onNegativeBtnClicked != null) {
                            OutlinedButton(
                                onClick = onNegativeBtnClicked,
                                modifier = Modifier
                                    .height(45.toScaleDp())
                                    .padding(start = 10.toScaleDp(), bottom = 10.toScaleDp())
                                    .pointerCursorIfEnabled(true),
                                shape = RoundedCornerShape(8.toScaleDp()),
                                border = BorderStroke(1.toScaleDp(), Color.Gray)
                            ) {
                                DisableSelection {
                                    Text(
                                        text = negativeBtnText,
                                        fontSize = 18.toScaleSp(),
                                        fontWeight = FontWeight.Medium,
                                        style = MaterialTheme.typography.button.copy(color = Color.Gray),
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                            Spacer(modifier = Modifier.width(24.toScaleDp()))
                        }
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Button(
                            onClick = onPositiveBtnClicked,
                            modifier = Modifier
                                .height(45.toScaleDp())
                                .padding(end = 10.toScaleDp(), bottom = 10.toScaleDp())
                                .pointerCursorIfEnabled(true),
                            shape = RoundedCornerShape(8.toScaleDp()),
                            colors = ButtonDefaults.buttonColors(
                                backgroundColor = BlueApp,
                                contentColor = Color.White
                            )
                        ) {
                            DisableSelection {
                                Text(
                                    text = positiveBtnText,
                                    fontSize = 18.toScaleSp(),
                                    fontWeight = FontWeight.Medium,
                                    style = MaterialTheme.typography.button,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun PopUpDialogNested(
    onDismiss: () -> Unit,
    onNegativeBtnClicked: (() -> Unit)? = null,
    onPositiveBtnClicked: () -> Unit,
    title: String,
    message: String,
    negativeBtnText: String? = null,
    positiveBtnText: String
) {
    NestedComposeViewPort {
        Dialog(
            onDismissRequest = onDismiss,
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Surface(
                shape = RoundedCornerShape(12.toScaleDp()),
                elevation = 8.toScaleDp(),
                color = Color.White,
                modifier = Modifier
                    .width(400.toScaleDp())
                    .wrapContentHeight()
                    .padding(16.toScaleDp())
            ) {
                Column(
                    modifier = Modifier
                        .padding(24.toScaleDp()),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SelectionContainer {
                        Text(
                            text = title,
                            fontSize = 22.toScaleSp(),
                            color = BlueApp,
                            fontWeight = FontWeight.SemiBold,
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 16.toScaleDp())
                        )
                    }
                    SelectionContainer {
                        Text(
                            text = message,
                            fontSize = 16.toScaleSp(),
                            lineHeight = 20.toScaleSp(),
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 24.toScaleDp())
                        )
                    }

                    // Action buttons
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        if (negativeBtnText != null && onNegativeBtnClicked != null) {
                            OutlinedButton(
                                onClick = onNegativeBtnClicked,
                                modifier = Modifier
                                    .height(45.toScaleDp())
                                    .clickableWithPointer { }
                                    .padding(start = 10.toScaleDp(), bottom = 10.toScaleDp()),
                                shape = RoundedCornerShape(8.toScaleDp()),
                                border = BorderStroke(1.toScaleDp(), Color.Gray)
                            ) {
                                Text(
                                    text = negativeBtnText,
                                    fontSize = 18.toScaleSp(),
                                    fontWeight = FontWeight.Medium,
                                    style = MaterialTheme.typography.button.copy(color = Color.Gray),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                            Spacer(modifier = Modifier.width(24.toScaleDp()))
                        }
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Button(
                            onClick = onPositiveBtnClicked,
                            modifier = Modifier
                                .height(45.toScaleDp())
                                .padding(end = 10.toScaleDp(), bottom = 10.toScaleDp())
                                .pointerCursorIfEnabled(true),
                            shape = RoundedCornerShape(8.toScaleDp()),
                            colors = ButtonDefaults.buttonColors(
                                backgroundColor = BlueApp,
                                contentColor = Color.White
                            )
                        ) {
                            Text(
                                text = positiveBtnText,
                                fontSize = 18.toScaleSp(),
                                fontWeight = FontWeight.Medium,
                                style = MaterialTheme.typography.button,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun ErrorDialog(
    onDismiss: () -> Unit,
    title: String,
    message: String,
    confirmationLink: Boolean? = false,
    onLinkClick: (() -> Unit)? = null
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        Surface(
            shape = RoundedCornerShape(12.toScaleDp()),
            elevation = 8.toScaleDp(),
            color = Color.White,
            modifier = Modifier
                .width(400.toScaleDp())
                .wrapContentHeight()
                .padding(16.toScaleDp())
        ) {
            Column(
                modifier = Modifier
                    .padding(24.toScaleDp()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SelectionContainer {
                    Text(
                        text = title,
                        fontSize = 22.toScaleSp(),
                        color = BlueApp,
                        fontWeight = FontWeight.SemiBold,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(bottom = 16.toScaleDp())
                    )
                }

                SelectionContainer {
                    Text(
                        text = message,
                        fontSize = 16.toScaleSp(),
                        lineHeight = 20.toScaleSp(),
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(bottom = if (confirmationLink == true) 12.toScaleDp() else 24.toScaleDp())
                    )
                }

                if (confirmationLink == true) {
                    Text(
                        text = stringResource(Res.string.resend_confirmation_link),
                        fontSize = 14.toScaleSp(),
                        lineHeight = 18.toScaleSp(),
                        textDecoration = TextDecoration.Underline,
                        color = BlueApp,
                        fontWeight = FontWeight.Bold,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .clickable { onLinkClick?.invoke() }
                            .padding(bottom = 24.toScaleDp())
                    )
                }

                Button(
                    onClick = onDismiss,
                    modifier = Modifier
                        .width(70.toScaleDp())
                        .height(40.toScaleDp())
                        .clickableWithPointer { },
                    shape = RoundedCornerShape(8.toScaleDp()),
                    colors = ButtonDefaults.buttonColors(
                        backgroundColor = BlueApp,
                        contentColor = Color.White
                    )
                ) {
                    Text(
                        text = stringResource(Res.string.ok),
                        fontSize = 18.toScaleSp(),
                        fontWeight = FontWeight.Medium,
                        textAlign = TextAlign.End
                    )
                }
            }
        }
    }
}

@Composable
fun ErrorDialogNested(
    onDismiss: () -> Unit,
    title: String,
    message: String,
    confirmationLink: Boolean? = false,
    onLinkClick: (() -> Unit)? = null
) {
    NestedComposeViewPort {
        Dialog(
            onDismissRequest = onDismiss,
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Surface(
                shape = RoundedCornerShape(12.toScaleDp()),
                elevation = 8.toScaleDp(),
                color = Color.White,
                modifier = Modifier
                    .width(400.toScaleDp())
                    .wrapContentHeight()
                    .padding(16.toScaleDp())
            ) {
                Column(
                    modifier = Modifier
                        .padding(24.toScaleDp()),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SelectionContainer {
                        Text(
                            text = title,
                            fontSize = 22.toScaleSp(),
                            color = BlueApp,
                            fontWeight = FontWeight.SemiBold,
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 16.toScaleDp())
                        )
                    }

                    SelectionContainer {
                        Text(
                            text = message,
                            fontSize = 16.toScaleSp(),
                            lineHeight = 20.toScaleSp(),
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = if (confirmationLink == true) 12.toScaleDp() else 24.toScaleDp())
                        )
                    }

                    if (confirmationLink == true) {
                        Text(
                            text = stringResource(Res.string.resend_confirmation_link),
                            fontSize = 14.toScaleSp(),
                            lineHeight = 18.toScaleSp(),
                            textDecoration = TextDecoration.Underline,
                            color = BlueApp,
                            fontWeight = FontWeight.Bold,
                            textAlign = TextAlign.Center,
                            modifier = Modifier
                                .clickable { onLinkClick?.invoke() }
                                .padding(bottom = 24.toScaleDp())
                        )
                    }

                    Button(
                        onClick = onDismiss,
                        modifier = Modifier
                            .width(70.toScaleDp())
                            .height(40.toScaleDp())
                            .clickableWithPointer { },
                        shape = RoundedCornerShape(8.toScaleDp()),
                        colors = ButtonDefaults.buttonColors(
                            backgroundColor = BlueApp,
                            contentColor = Color.White
                        )
                    ) {
                        Text(
                            text = stringResource(Res.string.ok),
                            fontSize = 18.toScaleSp(),
                            fontWeight = FontWeight.Medium,
                            textAlign = TextAlign.End
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun ErrorDialogWeb(
    onDismiss: () -> Unit,
    title: String,
    message: String,
    confirmationLink: Boolean? = false,
    onLinkClick: (() -> Unit)? = null
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Transparent)
            .clickable(onClick = onDismiss),
        contentAlignment = Alignment.Center
    ) {
        Card(
            modifier = Modifier.offset(x = (-80).toScaleDp()),
            elevation = 20.toScaleDp()
        ) {
            Box(
                modifier = Modifier
                    .width(300.toScaleDp())
                    .background(Color.White, shape = RoundedCornerShape(8.toScaleDp()))
                    .padding(20.toScaleDp()),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(
                        text = title,
                        fontSize = 22.toScaleSp(),
                        color = BlueApp,
                        fontWeight = FontWeight.W600,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                    Text(
                        text = message,
                        fontSize = 16.toScaleSp(),
                        fontWeight = FontWeight.W400,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                    )
                    if (confirmationLink == true) {
                        Spacer(modifier = Modifier.height(20.toScaleDp()))
                        Text(
                            text = stringResource(Res.string.resend_confirmation_link),
                            fontSize = 14.toScaleSp(),
                            textDecoration = TextDecoration.Underline,
                            color = BlueApp,
                            fontWeight = FontWeight.W700,
                            textAlign = TextAlign.Center,
                            modifier = Modifier.clickable { onLinkClick?.invoke() }
                        )
                    }
                    Spacer(modifier = Modifier.height(20.toScaleDp()))
                    TextButton(
                        onClick = { onDismiss() },
                        shape = RoundedCornerShape(8.toScaleDp()),
                        colors = ButtonDefaults.buttonColors(
                            backgroundColor = BlueApp,
                            contentColor = Color.White
                        )
                    ) {
                        Text(
                            stringResource(Res.string.ok),
                            fontSize = 18.toScaleSp(),
                            fontWeight = FontWeight.W500
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun FilterSection(
    title: String,
    options: List<String>,
    selectedOptions: Set<String>,
    onOptionSelected: (String) -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth().padding(start = 20.toScaleDp())) {
        androidx.compose.material3.Text(
            text = title,
            fontSize = 20.toScaleSp(),
            fontWeight = FontWeight.Bold
        )
        options.forEach { option ->
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                Checkbox(
                    modifier = Modifier.scale(1.toScaleDp().value),
                    checked = selectedOptions.contains(option),
                    onCheckedChange = { onOptionSelected(option) },
                    colors = CheckboxDefaults.colors(
                        checkedColor = BlueApp
                    )
                )
                androidx.compose.material3.Text(
                    text = option,
                    fontSize = 16.toScaleSp(),
                    color = FilterOption
                )
            }
        }
    }
}

@Composable
fun FilterSectionMobile(
    title: String,
    options: List<String?>,
    selectedOptions: Set<String>,
    onOptionSelected: (String) -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        androidx.compose.material3.Text(
            text = title,
            fontSize = 18.toScaleSp(),
            color = TextColor,
            modifier = Modifier.padding(top = 20.toScaleDp()),
            fontWeight = FontWeight.SemiBold,
        )
        Spacer(modifier = Modifier.height(10.toScaleDp()))
        options.forEach { option ->
            if (!option.isNullOrEmpty()) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().height(35.toScaleDp()),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    androidx.compose.material3.Text(
                        text = option,
                        fontSize = 14.toScaleSp(),
                        color = FilterOption,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.weight(1f)
                    )

                    Checkbox(
                        checked = selectedOptions.contains(option),
                        onCheckedChange = {
                            onOptionSelected(option)
                        },
                        colors = CheckboxDefaults.colors(
                            checkedColor = BlueApp,
                            uncheckedColor = AddEmployeeInputColor
                        ),
                        modifier = Modifier
                            .padding(bottom = 5.toScaleDp())
                            .scale(1.toScaleDp().value)
                            .pointerHoverIcon(PointerIcon.Hand)
                    )
                }
            }
        }
    }
}

@Composable
fun FilterSectionWeb(
    title: String,
    options: List<String?>,
    selectedOptions: Set<String>,
    onOptionSelected: (String) -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.toScaleDp())
    ) {
        androidx.compose.material3.Text(
            text = title,
            fontSize = 18.toScaleSp(),
            color = TextColor,
            modifier = Modifier.padding(
                top = 12.toScaleDp(),
                start = 16.toScaleDp(),
                bottom = 16.toScaleDp()
            ),
            fontWeight = FontWeight.SemiBold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        options.forEach { option ->
            if (!option.isNullOrEmpty()) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().height(40.toScaleDp()),
                ) {

                    Checkbox(
                        modifier = Modifier
                            .scale(1.toScaleDp().value)
                            .pointerHoverIcon(PointerIcon.Hand),
                        checked = selectedOptions.contains(option),
                        onCheckedChange = {
                            onOptionSelected(option)
                        },
                        colors = CheckboxDefaults.colors(
                            checkedColor = BlueApp,
                            uncheckedColor = com.hyperether.goodjob.theme.Divider
                        )
                    )
                    Spacer(modifier = Modifier.width(8.toScaleDp()))
                    androidx.compose.material3.Text(
                        text = option,
                        fontSize = 14.toScaleSp(),
                        color = FilterOption,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
    }
}

@Composable
fun NoteEditDialog(
    onDelete: () -> Unit,
    onEdit: () -> Unit
) {
    Card(
        modifier = Modifier
            .width(200.toScaleDp())
            .padding(top = 28.toScaleDp())
            .background(Color.White, shape = RoundedCornerShape(16.toScaleDp())),
        elevation = 4.toScaleDp()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Center
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickableWithPointer { onEdit() }
                    .padding(horizontal = 16.toScaleDp(), vertical = 12.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                DisableSelection {
                    Text(
                        text = stringResource(Res.string.edit),
                        fontSize = 14.toScaleSp(),
                        color = Color.Black
                    )
                }
            }
            Divider(
                color = Color(0xFFE9E9E9),
                thickness = 1.toScaleDp()
            )
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickableWithPointer { onDelete() }
                    .padding(horizontal = 16.toScaleDp(), vertical = 12.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                DisableSelection {
                    Text(
                        text = stringResource(Res.string.delete),
                        fontSize = 14.toScaleSp(),
                        color = Color.Red
                    )
                }
            }
        }
    }
}

fun saveLanguageToPref(languageCode: String) {
    val prefsManager = PrefsManager(Preferences())
    val language = AppLocale.entries.find { it.code == languageCode } ?: AppLocale.DEFAULT
    prefsManager.saveLanguage(language.code)
}

fun Modifier.pointerCursorIfEnabled(isEnabled: Boolean): Modifier =
    if (isEnabled) {
        this.pointerHoverIcon(PointerIcon.Hand)
    } else {
        this
    }

fun Modifier.clickableWithPointer(
    onClick: () -> Unit
): Modifier = this
    .then(
        pointerHoverIcon(PointerIcon.Hand)
    )
    .clickable(onClick = onClick)

@Composable
fun FilterButton(modifier: Modifier = Modifier) {
    IconButton(
        modifier = modifier,
        onClick = {
            FilterDialogStateManager.setDialogShowing(true)
        }
    ) {
        Icon(
            painter = painterResource(Res.drawable.filter_svgrepo_com_1),
            contentDescription = "Filter"
        )
    }
}

@Composable
fun WebFilterButton(
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .height(45.toScaleDp())
            .width(100.toScaleDp())
            .clip(RoundedCornerShape(8.toScaleDp()))
            .border(
                width = 1.toScaleDp(),
                color = BorderColor,
                shape = RoundedCornerShape(8.toScaleDp())
            )
            .clickableWithPointer {
                onClick()
            },
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        DisableSelection {
            Text(
                text = stringResource(Res.string.filter),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.W400,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Spacer(modifier = Modifier.width(5.toScaleDp()))
        Image(
            painter = painterResource(Res.drawable.filter_svgrepo_com_1),
            contentDescription = "Filter",
            modifier = Modifier
                .align(Alignment.CenterVertically)
                .padding(top = 5.toScaleDp())
        )
    }
}

@Composable
fun WebSearchField(
    text: String,
    onTextChange: (String) -> Unit,
    onDoneClick: () -> Unit = {}
) {
    BasicTextField(
        value = text,
        onValueChange = onTextChange,
        textStyle = TextStyle(fontSize = 12.toScaleSp(), color = Color.Black),
        singleLine = true,
        modifier = Modifier
            .width(226.toScaleDp())
            .height(45.toScaleDp())
            .background(Color.White, RoundedCornerShape(8.toScaleDp()))
            .border(1.toScaleDp(), BorderColor, RoundedCornerShape(8.toScaleDp()))
            .padding(8.toScaleDp()),
        decorationBox = { innerTextField ->
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxSize()
            ) {
                Image(
                    modifier = Modifier.size(24.toScaleDp()),
                    painter = painterResource(Res.drawable.ic_search),
                    contentDescription = "Search"
                )
                Spacer(modifier = Modifier.width(8.toScaleDp()))
                Box(Modifier.weight(1f), contentAlignment = Alignment.CenterStart) {
                    if (text.isEmpty()) {
                        Text(
                            text = stringResource(Res.string.search),
                            fontSize = 14.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            color = Color.Gray,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    innerTextField()
                }
            }
        },
        keyboardOptions = KeyboardOptions.Default.copy(
            imeAction = ImeAction.Done
        ),
        keyboardActions = KeyboardActions(onDone = {
            onDoneClick()
        })
    )
}